import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import StudentDashboard from './dashboards/StudentDashboard';
import ParentDashboard from './dashboards/ParentDashboard';
import TutorDashboard from './dashboards/TutorDashboard';
import AdminDashboard from './dashboards/AdminDashboard';

const DashboardRouter = () => {
  const { user, activeRole, loading } = useAuth();

  // Wait for session restoration before deciding to redirect (prevents logout on refresh)
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50" data-testid="dashboard-loading">
        <div className="w-12 h-12 border-4 border-cyan-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Use activeRole (for multi-role users) or fallback to primary role
  const currentRole = activeRole || user.role;

  switch (currentRole) {
    case 'student':
      return <StudentDashboard />;
    case 'parent':
      return <ParentDashboard />;
    case 'tutor':
      return <TutorDashboard />;
    case 'admin':
      return <AdminDashboard />;
    default:
      return <Navigate to="/login" />;
  }
};

export default DashboardRouter;